import React from "react";
import { Box } from "../../../../../../shared/Box/Box";
import { Skeleton } from "../../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../../shared/Empty/Empty";
import { Table as SharedTable } from "../../../../../../shared/Table/Table";
import {
  tCommon,
  useAppTranslation,
} from "../../../../../../i18n/useAppTranslation";
import styles from "./styles.module.scss";
import { DeleteAction } from "./shared/DeleteAction/DeleteAction";
import { history } from "../../../../../../history";
import { ROUTES } from "../../../../../../consts/routes";

export const FavoritesTable = ({ favorites }) => {
  const { tSettings } = useAppTranslation.Settings();

  const data = favorites.value.map((r) => ({
    key: r.id,
    name: r.name,
    lastModifiedBy: r.lastModifiedBy || tCommon("symbol.longDash"),
    number: r.faxNumber,
    actions: (
      <div className={styles.actions}>
        <DeleteAction id={r.id} />
      </div>
    ),
  }));

  const isEmpty = !favorites.isFavoritesLoading && !favorites.value.length;
  const isVisible = !favorites.isFavoritesLoading && !isEmpty;

  return (
    <Box>
      {favorites.isFavoritesLoading && (
        <Skeleton count={15} height={40.5} borderRadius="0px" />
      )}
      {isEmpty && <Empty position="center" />}
      {isVisible && (
        <SharedTable
          bgColor="white"
          data={data}
          onRowClick={(row) => {
            history.push(ROUTES.settings.editEfaxFavorite(row.key));
          }}
          preventRowClickForAccessors={["actions"]}
          cols={[
            {
              data: tSettings("efaxTemplates.favoritesTable.name"),
              accessor: "name",
              headColClassName: styles.col,
            },
            {
              data: tSettings("efaxTemplates.favoritesTable.number"),
              accessor: "number",
              headColClassName: styles.col,
            },
            {
              data: tSettings("efaxTemplates.favoritesTable.lastModifiedBy"),
              accessor: "lastModifiedBy",
              headColClassName: styles.col,
            },
            {
              data: "",
              accessor: "actions",
            },
          ]}
        />
      )}
    </Box>
  );
};
